/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';
import { ContactMethod } from './contactMethod';
import { NaturalPerson } from './naturalPerson';
import { PartnershipCard } from './partnershipCard';
import { SecurityInfo } from './securityInfo';

export interface UserRequest {
  applicationName?: string;
  contactMethods?: Array<ContactMethod>;
  naturalPerson?: NaturalPerson;
  partnershipCard?: Array<PartnershipCard>;
  securityInfo?: SecurityInfo;
  userAddr?: Address;
  userId?: string;
  type?: UserRequest.TypeEnum;
}
export namespace UserRequest {
  export type TypeEnum =
    | 'CHANGE_EMAIL'
    | 'RECOVERY_PASSWORD'
    | 'INVITE_TO_REGISTER'
    | 'REGISTRATION_CONFIRMATION'
    | 'MYLS'
    | 'AGGREGATOR_QUOTATION'
    | 'GW_QUOTATION'
    | 'SECURE_PIN';
  export const TypeEnum = {
    CHANGEEMAIL: 'CHANGE_EMAIL' as TypeEnum,
    RECOVERYPASSWORD: 'RECOVERY_PASSWORD' as TypeEnum,
    INVITETOREGISTER: 'INVITE_TO_REGISTER' as TypeEnum,
    REGISTRATIONCONFIRMATION: 'REGISTRATION_CONFIRMATION' as TypeEnum,
    MYLS: 'MYLS' as TypeEnum,
    AGGREGATORQUOTATION: 'AGGREGATOR_QUOTATION' as TypeEnum,
    GWQUOTATION: 'GW_QUOTATION' as TypeEnum,
    SECUREPIN: 'SECURE_PIN' as TypeEnum,
  };
}
